import { gsap } from 'gsap';

/***
 * Source
 * https://codepen.io/manuelpette/pen/qBNLdex
 * ***/

// Suppressing gsap warnings about null targets
//gsap.config({ nullTargetWarn: false });
/***
 * Source
 * https://codepen.io/manuelpette/pen/qBNLdex
 * ***/

// Suppressing gsap warnings about null targets
//gsap.config({ nullTargetWarn: false });

var onOpenStart = function (box) {
  box.setAttribute('data-collapse-status', 'open');
  box.setAttribute('data-collapse-animating', 'true');

  var linkedElements = box.getAttribute('data-collapse-box');

  if (linkedElements) {
    var boxCnt = document.querySelector(
      '[data-collapse-cnt="' + linkedElements + '"]',
    );
    boxCnt.setAttribute('data-collapse-status', 'open');
    boxCnt.setAttribute('data-collapse-animating', 'true');
  }
};

var onCloseStart = function (box) {
  box.setAttribute('data-collapse-status', '');
  box.setAttribute('data-collapse-animating', 'true');

  var linkedElements = box.getAttribute('data-collapse-box');

  if (linkedElements) {
    var boxCnt = document.querySelector(
      '[data-collapse-cnt="' + linkedElements + '"]',
    );
    boxCnt.setAttribute('data-collapse-status', '');
    boxCnt.setAttribute('data-collapse-animating', 'true');
  }
};

var onOpenComplete = function (box) {
  box.setAttribute('data-collapse-animating', '');

  var linkedElements = box.getAttribute('data-collapse-box');

  if (linkedElements) {
    var boxCnt = document.querySelector(
      '[data-collapse-cnt="' + linkedElements + '"]',
    );
    boxCnt.setAttribute('data-collapse-animating', '');
  }
};

var onCloseComplete = function (box) {
  box.setAttribute('data-collapse-animating', '');

  var linkedElements = box.getAttribute('data-collapse-box');

  if (linkedElements) {
    var boxCnt = document.querySelector(
      '[data-collapse-cnt="' + linkedElements + '"]',
    );
    boxCnt.setAttribute('data-collapse-animating', '');
  }
};

var animationSpeed = function (box) {
  var speed = box.getAttribute('data-collapse-speed');
  switch (speed) {
    case 'slow':
      return 0.6;
    case 'medium':
      return 0.3;
    case 'fast':
      return 0.15;
    case 'none':
      return 0;
    default:
      return 0.3;
  }
};

var open = function (box, set) {
  var linkedElements = box.getAttribute('data-collapse-box');

  if (linkedElements) {
    var boxCnt = document.querySelector(
      '[data-collapse-cnt="' + linkedElements + '"]',
    );
  } else {
    var boxCnt = box.querySelector('[data-collapse-cnt]');
  }

  var speed = animationSpeed(box);

  if (set) {
    gsap.set(boxCnt, {
      height: 'auto',
      onStart: onOpenStart,
      onStartParams: [box],
      onComplete: onOpenComplete,
      onCompleteParams: [box],
    });
  } else {
    gsap.to(boxCnt, speed, {
      height: 'auto',
      onStart: onOpenStart,
      onStartParams: [box],
      onComplete: onOpenComplete,
      onCompleteParams: [box],
    });
  }
};

var close = function (box) {
  var linkedElements = box.getAttribute('data-collapse-box');

  if (linkedElements) {
    var boxCnt = document.querySelector(
      '[data-collapse-cnt="' + linkedElements + '"]',
    );
  } else {
    var boxCnt = box.querySelector('[data-collapse-cnt]');
  }

  var speed = animationSpeed(box);
  gsap.to(boxCnt, speed, {
    height: getComputedStyle(boxCnt).minHeight,
    onStart: onCloseStart,
    onStartParams: [box],
    onComplete: onCloseComplete,
    onCompleteParams: [box],
  });
};

var init = function () {
  Array.prototype.slice
    .call(document.querySelectorAll('[data-collapse-box]'))
    .map(function (box) {
      // Detached mode
      var linkedElements = box.getAttribute('data-collapse-box');

      if (linkedElements) {
        var boxHeads = document.querySelectorAll(
          '[data-collapse-head="' + linkedElements + '"]',
        );
        var boxCnt = document.querySelector(
          '[data-collapse-cnt="' + linkedElements + '"]',
        );
      } else {
        var boxHeads = box.querySelectorAll('[data-collapse-head]');
        var boxCnt = box.querySelector('[data-collapse-cnt]');
      }

      var boxGroup = box.getAttribute('data-collapse-group');

      if (!boxHeads.length > 0 || !boxCnt) return;

      boxHeads.forEach((boxHead) =>
        boxHead.addEventListener('click', function () {
          if (boxGroup) {
            var groupBoxes = Array.prototype.slice.call(
              document.querySelectorAll(
                '[data-collapse-group="' + boxGroup + '"]',
              ),
            );
            groupBoxes.map(function (el) {
              if (el !== box) {
                close(el);
              }
            });
          }

          box?.dataset?.collapseStatus === 'open' ? close(box) : open(box);
        }),
      );

      // Support for "open on load"
      if (box.getAttribute('data-collapse-status') === 'open') {
        open(box, true);
      }
    });
};

if (document.readyState != 'loading') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}

export { open, close };
